import angular from 'angular'

import component from './product-filters.component'

let module = angular.module('productFilters', [])

.component('productFilters', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/product-filters/index.js